<div class="h-full w-full flex align-items-center justify-content-center">
  <p clas="text-color text-lg">Logging out...</p>
</div>
